/*
 * SC scroll reveal (2026-10-14) — Swiss Collectors sections fade + slide up (28px) as they enter the viewport,
 * staggered among siblings (like the original site). Loaded only when Theme settings → Swiss Collectors →
 * "Scroll reveal animations" is on (layout/theme.liquid).
 * Progressive enhancement: nothing is hidden unless this script runs, IntersectionObserver exists and the visitor has
 * not asked for reduced motion. Heroes, header, footer and product forms are never targeted.
 * When an element has finished revealing, its reveal classes are removed so its own hover transitions work again.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var TARGETS = [
    '.sc-section-header',
    '.sc-feature-grid__item',
    '.sc-event-card',
    '.sc-exhibitor-event',
    '.sc-package',
    '.sc-partner__tile',
    '.sc-partner-opps__item',
    '.sc-stats__item',
    '.sc-faq__item',
    '.sc-gallery__item',
    '.sc-next-event__card',
    '.sc-event-plan__item',
    '.sc-event-location__card',
    '.sc-event-notify__card',
    '.sc-event-content__inner',
    '.sc-event-cta__inner',
    '.sc-event-exhibitors__disclosure',
    '.sc-cta-banner__inner',
    '.sc-editorial__inner',
    '.sc-stay-updated__inner'
  ].join(',');
  var EXCLUDE = '.sc-home-hero, .sc-event-hero, header, footer, product-form-component, [data-sc-booking]';
  var MAX_STAGGER = 5;
  var CLEANUP_MS = 1300; // 0.65s transition + max stagger delay + margin

  document.documentElement.classList.add('sc-reveal-on');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        el.classList.add('is-in');
        window.setTimeout(function () {
          el.classList.remove('sc-reveal', 'is-in');
          el.style.removeProperty('--sc-reveal-i');
        }, CLEANUP_MS);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  );

  function scan(root) {
    var found = Array.prototype.slice.call((root || document).querySelectorAll(TARGETS));
    found.forEach(function (el) {
      if (el.dataset.scRevealed || el.closest(EXCLUDE)) return;
      // Only the outermost target animates (no double animation for nested targets).
      var parent = el.parentElement && el.parentElement.closest(TARGETS);
      if (parent && !parent.closest(EXCLUDE)) return;
      el.dataset.scRevealed = 'true';
      // Already on screen when the script runs → leave it as is (no hide-then-show flicker).
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      var index = 0;
      var sibling = el.previousElementSibling;
      while (sibling && index < MAX_STAGGER) {
        if (sibling.matches(TARGETS)) index++;
        sibling = sibling.previousElementSibling;
      }
      el.style.setProperty('--sc-reveal-i', index);
      el.classList.add('sc-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  // Theme Editor: re-scan a re-rendered section
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
